import { render, staticRenderFns } from "./EntranceMajorMulti.vue?vue&type=template&id=a6874878&scoped=true&"
import script from "./EntranceMajorMulti.vue?vue&type=script&lang=js&"
export * from "./EntranceMajorMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6874878",
  null
  
)

export default component.exports